import React from 'react'
import injectSheet from 'react-jss'
import styles from './provider-button.styles'

const ProviderButton = ({ classes, color, Icon, ...props }) => (
  <div
    role="button"
    style={{ backgroundColor: color }}
    className={classes.container}
    {...props}>
    <Icon className={classes.icon} />
  </div>
)

export default injectSheet(styles)(ProviderButton)
